



















import {
  defineComponent,
  useFetch,
  watch,
  useRoute,
  computed,
  useMeta,
  onActivated,
} from '@nuxtjs/composition-api'
import {
  provideProductCategory,
  injectProductCategory,
} from '~/composables/product/useProductCategory'
import { ProductEvents } from '~/composables/product/useProduct'
import { provideProductList } from '~/composables/product/useProductList'
import { useEvents } from '~/composables/framework/useEvents'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useContent } from '~/composables/useContent'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'
import { htmlToText } from '~/lib/utilities'

export default defineComponent({
  name: 'PagesProductLister',

  setup() {
    provideProductList()
    provideProductCategory()

    const { emit } = useEvents()
    const route = useRoute()
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const useProductCategoryData = injectProductCategory()
    const { category, products, initialize } = useProductCategoryData
    const { article, htmlMeta, ensureContent, setPageMeta } = useContent()
    const { breadcrumbsSchemaScript, setBreadcrumbsSchemaScript } =
      useBreadcrumbsSchemaScript()

    const categoryName = computed(
      () =>
        category.value?.name ??
        route.value.params.pathMatch.split('/')[-1]?.replace('-', ' ') ??
        ''
    )
    const categoryId = computed(() => category.value?.id ?? null)

    const doSetBreadcrumbs = () => {
      if (!category.value || breadcrumbs.value?.length) return

      setBreadcrumbs([
        ...(category.value.ancestors ?? []).map((ancestor) => ({
          to: {
            name: 'product-lister-all',
            params: { pathMatch: ancestor.url as string },
          },
          label: ancestor.name,
        })),
        {
          label: categoryName.value,
        },
      ])
    }

    useFetch(async () => {
      await Promise.all([
        initialize(route.value.params.pathMatch),
        ensureContent(),
      ])

      if (!category.value) return

      setPageMeta({
        title: article.value?.title || categoryName.value,
        description: htmlToText(
          article.value?.description ?? category.value?.description ?? ''
        ),
        img: category.value.img,
      })

      doSetBreadcrumbs()
      setBreadcrumbsSchemaScript(breadcrumbs.value!)
    })

    onActivated(() => {
      doSetBreadcrumbs()
    })

    useMeta(() => htmlMeta.value)
    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    if (process.client) {
      // Emit ViewList event
      if (products.value && products.value.length) {
        emit(ProductEvents.ViewList, {
          products: products.value,
          webNode: category.value,
        })
      }
      watch(products, (value) => {
        if (!value || !value.length) return
        emit(ProductEvents.ViewList, {
          products: value,
          webNode: category.value,
        })
      })
    }

    const useBlocks = computed(() => article.value?.useBlocks)

    const pageBanner = computed(() => {
      return article.value?.images?.[0]?.src ?? category.value?.banner
    })

    const pageAbout = computed(() => {
      return article.value?.summary ?? category.value?.description
    })

    return {
      categoryName,
      categoryId,

      useBlocks,
      pageBanner,
      pageAbout,
      ...useProductCategoryData,
    }
  },

  head: {},
})
